import React, { useState, FunctionComponent } from 'react';
import { RouteComponentProps, navigate } from '@reach/router';
import { verifyCode } from '@v10-codeparva/v10-tfw-revamp-package-api';
import { ForgotPasswordTokenForm } from '../forgotPassword/ForgotPassword';
import { Spinner } from '@chakra-ui/react';
import { useCookie } from 'utils/auth';
import { localisable } from '../../../generic/localisable';

const navigateTo = (route: string) => {
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
    const pathSegments = currentPath.split('/');
    // Keep only the segments up to and including "pay-rent"
    const basePath = pathSegments.slice(0, pathSegments.indexOf('pay-rent') + 1).join('/');
    navigate(`${basePath}/${route}`);
};

export const ForgotPasswordVerifyCodePage: FunctionComponent<RouteComponentProps> = () => {
    const [emailError, setEmailError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [_, setCPasswordToken] = useCookie('cPasswordToken')

    const onSubmitVerifyCodeHandler = async (formData: any) => {
        setIsLoading(true);
        const {
            email,
            token
        } = formData;
        const verifyCodeReq = {
            strEmailID: email,
            strPasswordToken: token,
            cid: process.env.CID || '',
        }
        setCPasswordToken(token);
        verifyCode(verifyCodeReq).then((verifyCodeApiResponse) => {
            setEmailError('');
            const { blnSuccess } = verifyCodeApiResponse;
            setIsLoading(false);
            if (blnSuccess) {
                navigateTo('reset')
            }
            else {
                setEmailError(localisable.userNameAndCredentialsError);
            }
        }).catch((error) => {
            if (error.response) {
                console.log(error.response.data); // => the response payload 
            }
            setEmailError(localisable.userNameAndCredentialsError);
        })
    };

    return <>
        {
            isLoading ? <Spinner size={'xl'} /> :
                <ForgotPasswordTokenForm
                    forgotPasswordTokenError={emailError}
                    onSubmitTokenForm={onSubmitVerifyCodeHandler}
                />
        }
    </>

};
